<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{'Trending Company Report'}}</strong>
        </div>
        <div class="col-md-2">
          <download :tableId="'trending-company'" :fileName="'trending-company'"></download>
        </div>
        <!-- <div class="col-md-1">
          <goback></goback>
        </div> -->
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <v-select
              :options="companyList"
              :placeholder="'Select Company'"
              :label="'companyname'"
              v-model="selComp"
              @input="getCompData"
            >
              <!-- <div class="spinner" v-show="spinner">Loading...</div> -->
            </v-select>
          </div>
        </div>
      </div>
      <div class="table-responsive app" v-dragscroll="true">
        <table
          id="trending-company"
          class="table table-sm first-td-padding table-bordered app-inner"
        >
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="field in tableFields" v-bind:key="'field'+field.title">{{field.title}}</th>
              <th v-if="actions.length>0">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row,index) in fillableData" v-bind:key="'row'+index">
              <td>
                <span>{{(index+1)}}</span>
                <!-- <span>{{(index+1)+(perPage*($refs.page.current_page-1))}}</span> -->
              </td>
              <td v-for="field in tableFields" v-bind:key="field.name+index">
                <span v-if="field.name==='date'">{{getDateTime(row[field.name])}}</span>
                <span
                  v-else-if="field.name==='name'"
                >{{(row['first_name'])? row['first_name'] + ' ' + row['last_name']: '-'}}</span>
                <span v-else>{{row[field.name]}}</span>
              </td>
              <td v-if="actions.length>0">
                <div class="action-btn-wrapper">
                  <a
                    style="margin:1px 4px"
                    class="btn btn-sm btn-small"
                    :class="action.btnClass"
                    v-for="action in actions"
                    v-bind:key="'action'+action.tooltip"
                    @click.prevent="action.callback(row,index,$event)"
                  >
                    <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.length==0">
            <tr>
              <td :colspan="(tableFields.length+actions.length+1)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
        <pagination
          ref="page"
          :pageName="pageType"
          :totPages="totalPages"
          :apiUrl="apiUrl"
          @changePage="pageChange"
        ></pagination>
      </div>
      <!-- </card> -->
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";

export default {
  mixins: [commonMixins],
  name: "UserActivityReport",
  created() {
    this.getCompaniesList();
  },
  watch: {
    reload() {
      this.fillTable();
    }
  },
  data() {
    return {
      apiUrl: "trendingCompanyReport",
      pageType: "trending-company",
      perPage: 100,
      apiMode: true,
      companyList: [],
      lastSelectItem: {},
      selComp: "",
      company: { co_code: "", companyname: "" },
      actions: [
        {
          btnClass: "btn-info",
          icon: "fa-eye cwhite",
          callback: this.viewUsers,
          tooltip: "View Users"
        }
      ],
      tableFields: [
        // {
        //   name: "co_code",
        //   title: "Company Code"
        // },
        {
          name: "co_name",
          title: "Company"
        },
        {
          name: "count",
          title: "Count"
        },
        {
          name: "date",
          title: "Date Time"
        }
      ],
      paginationPath: "",
      searchParams: {},
      sectorData: [],
      fillableData: [],
      url: "",
      page: 1,
      totalPages: 1
    };
  },
  methods: {
    search() {
      console.log(this.searchParams);
      if (
        this.searchParams.companyname.length > 2 ||
        this.searchParams.sectorname != ""
      ) {
        if (this.searchParams.sectorname != "") {
          localStorage.setItem("secC", this.searchParams.sectorname);
        }
        this.fetchData(this.searchParams);
      }
      if (
        this.searchParams.companyname.length == 0 &&
        this.searchParams.sectorname == ""
      ) {
        console.log("Reset");
        this.reset();
      } else {
        console.log("Not Reset");
      }
      // this.$refs.search.searchIn(this.searchParams);
    },
    viewUsers(row, ind, ele) {
      this.$router.push({
        name: "trending-company-users",
        params: { id: row.co_code }
      });
    },
    getCompaniesList() {
      let _this = this;
      http.get("getCompanyMaster", {}, function(error, response) {
        var companyList = response;
        if (companyList.length > 0) {
          _this.companyList = _this.sorted_fields_asc(
            companyList,
            "companyname"
          );
        }
        _this.fetchData();
      });
    },
    reset() {
      // window.location.reload();
      this.$router.push({ name: "trending-company-report" });
      this.searchParams = {};
      this.current_page = 1;
      this.url = this.apiUrl;
      this.fetchData();
    },
    fetchData(data = null) {
      if (this.url !== "") {
        console.log("=====" + this.url + "========");
        let myself = this;
        let params = data
          ? { pageid: myself.page, co_code: myself.selComp.co_code }
          : { pageid: myself.page };
        http.post(this.apiUrl, params, function(error, response) {
          console.log(response);
          // if (response.responseType === "success") {
          myself.fillableData = response.final_data;
          myself.totalPages = response.total_pages;
          // } else {
          //   console.log(error);
          // }
        });
      } else {
        console.log("=====" + this.url + "========");
      }
    },
    pageChange(url) {
      console.log("changeUrl", url);
      this.url = url;
      this.page = url.page;
      this.fetchData();
    },
    getCompData() {
      this.fetchData(this.selComp);
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/reports/trending-company.vue